import { Theme } from "common";

export const tableauReportStyles = {
  paper: {
    margin: `${Theme.spacing(1)}px auto`,
    padding: Theme.spacing(2),
  },
  descContainer: {
    paddingLeft: Theme.spacing(5),
  },
};
